import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import moment from 'moment';
import './WeekDayPicker.scss';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { ARABIC } from 'shared/constants';
import 'moment/locale/ar';


const WeekDayPicker = (props) => {
  if (props.intl.locale === ARABIC) {
    moment.locale('ar');
  } else {
    moment.locale('en');
  }

  const [isSelected, setSelect] = useState(false);
  /**
   * Submit date selected
   * @param {dateSelected} e
   */
  const handleSubmit = (e) => {
    // work around for click bug on label after swipe
    e.preventDefault();
    const checkbox = e.target.querySelector('input');

    // eslint-disable-next-line radix
    if (checkbox.disabled) return;
    // if (moment().isSameOrAfter(moment(parseInt(checkbox.value)), 'day')) return;

    if (!isSelected) {
      setSelect(true);
      checkbox.checked = !checkbox.checked;
      const { onSubmit } = props;
      // console.log('date', parseInt(checkbox.value));
      onSubmit(
        // eslint-disable-next-line radix
        moment(parseInt(checkbox.value)).format('dddd, D MMMM YYYY'), { toTranslate: false, pureDate: moment(parseInt(checkbox.value)) },
      );
    }
  };

  /**
     * Added initial date to make appointment only after april 10
     */
  const initialDate = moment().isAfter(moment('2020-04-10')) ? new Date() : '2020-04-10';

  /**
   * Render days of week
   * @param {*} firstDay
   */
  const renderDaysOfWeek = (firstDay) => {
    const daysOfWeek = [];

    // eslint-disable-next-line no-plusplus
    for (let i = firstDay; i < (firstDay + 5); i++) {
      daysOfWeek.push(
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
        <li key={i} className={`select-option ${moment(initialDate).day(i).isSameOrBefore(moment().add(2, 'day'), 'day') ? 'select-option--disabled' : ''}`} onClick={handleSubmit}>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */}
          <label>
            {moment(initialDate).day(i).format('dddd, D MMMM')}
            <input type="checkbox" value={moment(initialDate).day(i)} disabled={moment(initialDate).day(i).isSameOrBefore(moment().add(2, 'day'), 'day')} />
            <span className="select-option__checkmark" />
          </label>
        </li>,
      );
    }
    return daysOfWeek;
  };

  /**
   * Render Weeks
   */
  const renderWeeks = () => {
    const weeks = [];
    const { intl, startOfWeek } = props;
    const firstDay = startOfWeek === 'saturday' ? 7 : 1;

    for (let i = 0; i < 4; i += 1) {
      weeks.push(
        <section className="weekday-picker__container" key={`week${i}`}>
          <div className="weekday-picker__title">
            {intl.formatMessage({ id: 'weekday.Picker.Title' }, { day: moment(initialDate).day(firstDay + i * 7).format('D MMMM') })}
          </div>
          <ul>{renderDaysOfWeek(firstDay + i * 7)}</ul>
        </section>,
      );
    }
    return weeks;
  };

  /**
   * Slider settings
   */
  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: props.rtl,
    // initialSlide: moment().isSameOrAfter(moment().day(5)) ? 1 : 0, // move to next week if today is friday of this week
    initialSlide: 0
  };

  const classes = classNames({
    'weekday-picker': true,
    'weekday-picker--rtl': props.rtl,
  });

  return (
    <Slider {...settings} className={classes}>
      {renderWeeks()}
    </Slider>
  );
};

WeekDayPicker.propTypes = {
  /** Start of the week */
  startOfWeek: PropTypes.string,
  /** Day Selection */
  onSubmit: PropTypes.func,
  /** is RTL */
  rtl: PropTypes.bool,
};

WeekDayPicker.defaultProps = {
  startOfWeek: 'sunday',
  onSubmit: () => {},
  rtl: false,
};

export default injectIntl(WeekDayPicker);
